import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setBusinessNameList, setFormAndTaxYearList, setFormBoxLabels, setFormSettings, setImportData, setIsImportDataGridViewLoaded, setIsPaymentNotMapped, setLoadingState, setPayerEntityFilters, setPayersList, setTipaltiRedirectUrl } from "./TipaltiSlice";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import PayerDataService from "../../../../../services/PayerDataService";
import General from "../../../../../libs/utility/General";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import FormsDataService from "../../../../../services/FormsDataService";
import { TIPALTI_LOADING_STATES } from "../constants";

export const { getPayersList, getTipaltiRedirectUrl, processTipaltiTokenUpdate, getFormAndTaxYearList, getPayerEntityFilters, getTipaltiLoadOrImportData, getLoadImportData, getFormLabels, getFormSetting } = {
    getPayersList: (payload) => {
        return {
            type: "TIPALTI/GET_PAYERS",
            payload: payload
        }
    },
    getTipaltiRedirectUrl: (payload) => {
        return {
            type: "TIPALTI/GET_TIPALTI_REDIRECT_URL",
            payload: payload
        }
    },
    processTipaltiTokenUpdate: (payload) => {
        return {
            type: "TIPALTI/TIPALTI_TOKEN_UPDATE",
            payload: payload
        }
    },
    getFormAndTaxYearList: (payload) => {
        return {
            type: "TIPALTI/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    getPayerEntityFilters: (payload) => {
        return {
            type: "TIPALTI/GET_PAYER_ENTITY_FILTERS",
            payload: payload
        }
    },
    getTipaltiLoadOrImportData: (payload) => {
        return {
            type: "TIPALTI/GET_TIPALTI_REPORT_API",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "TIPALTI/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormLabels: (payload) => {
        return {
            type: "TIPALTI/GET_GETFORM_LABELS",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "TIPALTI/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: TIPALTI_LOADING_STATES.DROPDOWNS_LOADING }));
        const response = yield PayerDataService.getPayersList();

        const { Data, Message, Status } = response?.data;
        if (Status) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "LastName", "IdNumber")
                yield put(setPayersList(Data));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the data. Please try again later or contact our support team for assistance." }));
    }
    finally {
        yield put(setLoadingState({ state: TIPALTI_LOADING_STATES.DROPDOWNS_DATA_READY }));
    }
}

function* getTipaltiRedirectUrlAsync() {

    try {
        const response = yield IntegrationDataService.getRedirectUrl();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response?.data?.Data) {
                yield put(setTipaltiRedirectUrl(response?.data?.Data));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to fetch Xero Url",
            message: "An error occurred while fetching the data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
}
function* processTipaltiTokenUpdateAsync(action) {
    try {
        yield put(setLoadingState({ state: TIPALTI_LOADING_STATES.DROPDOWNS_LOADING }));
        const { tipaltiQueryParam } = action.payload;
        const response = yield IntegrationDataService.tipaltiTokenUpdate(tipaltiQueryParam);

        if (response?.data?.Status === 1) {
            if (response?.data?.Data?.length > 0) {
                yield put(setBusinessNameList(response?.data?.Data));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: response?.data?.Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({
            heading: "Error",
            message: "An error occurred while fetching the data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
    finally {
        yield put(setLoadingState({ state: TIPALTI_LOADING_STATES.DROPDOWNS_DATA_READY }));
    }
}
function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: TIPALTI_LOADING_STATES.DROPDOWNS_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {

            if (response?.data?.Data) {
                yield put(setFormAndTaxYearList(response?.data?.Data));
            } else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch TaxYear And Form Types",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch TaxYear And Form Types", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance." }));
    }
    finally {
        yield put(setLoadingState({ state: TIPALTI_LOADING_STATES.DROPDOWNS_DATA_READY }));
    }
}
function* getPayerEntityFiltersAsync(action) {
    try {
        const response = yield IntegrationDataService.payerEntityFilters(action.payload);
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {

            if (response?.data?.Data) {
                yield put(setPayerEntityFilters(response?.data?.Data));
            } else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Payer Entity Filters",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }

        }
    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance." }));
    }
}
function* getTipaltiLoadOrImportDataAsync(action) {
    try {
        const { tipatiModel } = action.payload;
        const response = yield IntegrationDataService.getTipaltiLoadOrImportData(tipatiModel);

        if (response?.data?.Status === 1) {
            yield put(setIsPaymentNotMapped(true));
        } else {
            yield put(addNotifications({
                heading: "Error",
                message: 'Failed to fetch data'
            }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance." }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response?.data?.Data) {
                yield put(setImportData(response?.data?.Data));
                yield put(setIsImportDataGridViewLoaded(true));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Import Data",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: error?.response?.data?.Message }));
    }
}
function* getFormLabelsAsync() {
    try {
        const response = yield IntegrationDataService.getFormLabels();
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response?.data?.Data) {
                yield put(setFormBoxLabels(response?.data?.Data));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Form Labels",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Form Labels", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance." }));
    }
}
function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {

                if (response?.data?.Data) {
                    yield put(setFormSettings(response?.data?.Data));
                }
                else {
                    yield put(addNotifications({
                        heading: "Error",
                        message: "Failed to fetch data",
                        variant: TOASTER_VARIANT.DANGER
                    }));
                }

            } else {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
}
function* rootSaga() {
    yield all([
        takeLatest(getPayersList().type, getPayersListAsync),
        takeLatest(getTipaltiRedirectUrl().type, getTipaltiRedirectUrlAsync),
        takeLatest(processTipaltiTokenUpdate().type, processTipaltiTokenUpdateAsync),
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(getPayerEntityFilters().type, getPayerEntityFiltersAsync),
        takeLatest(getTipaltiLoadOrImportData().type, getTipaltiLoadOrImportDataAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormLabels().type, getFormLabelsAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);